import { ScrollArea } from '@pocketlaw/tetris';
import { FloatingSidebarBody } from './styled';
export function Body(props) {
    const { scrollable = true, children } = props;
    return <FloatingSidebarBody>{scrollable ? <ScrollArea>{children}</ScrollArea> : children}</FloatingSidebarBody>;
}
